import React from "react";

export default function Loader({isLoading}) {    
  return (
    <div className={`loader-container ${isLoading === true ? 'd-static' : 'd-none'}`} >
        <div className="spinner"></div>
    </div>
  );
}